export const ExamRoutes = [
  // Exams
  {
    path: '/exams',
    component: () => import('@/views/exam/Exam.vue'),
    name: 'Kỳ thi',
    meta: {
      title: 'Danh sách kỳ thi',
      auth: true
      // permission: 'view-class-list',
    }
  },
  {
    path: '/exams/:id',
    component: () => import('@/views/exam/ExamDetailsPage.vue'),
    name: 'Kỳ thi',
    meta: {
      title: 'Thông tin kỳ thi',
      auth: true
    }
  },
  {
    path: '/student-exam',
    component: () => import('@/views/exam/StudentExamPage.vue'),
    name: 'Kỳ thi',
    meta: {
      title: 'Thông tin kỳ thi',
      auth: true
      // permission: 'view-class-list',
    }
  },
  {
    path: '/exam-lookup',
    component: () => import('@/views/exam/student/StudentExamPage.vue'),
    name: 'Kỳ thi',
    meta: {
      title: 'Tra soát kỳ thi',
      auth: true
      // permission: 'view-class-list',
    }
  },
  {
    path: '/student-exam-marks',
    component: () => import('@/views/exam/student/StudentMarksPage.vue'),
    name: 'Kỳ thi',
    meta: {
      title: 'Kết quả',
      auth: true
      // permission: 'view-class-list',
    }
  },
  {
    path: '/student-mark-review',
    component: () => import('@/views/exam/student/StudentMarkReviewPage.vue'),
    name: 'Kỳ thi',
    meta: {
      title: 'Phúc khảo',
      auth: true
      // permission: 'view-class-list',
    }
  },
  {
    path: '/exam-absent',
    component: () => import('@/views/exam/ExamAbsentPage.vue'),
    name: 'Kỳ thi',
    meta: {
      title: 'Biên bản thi',
      auth: true
      // permission: 'view-class-list',
    }
  },
  {
    path: '/exam-code',
    component: () => import('@/views/exam/ExamCodePage.vue'),
    name: 'Kỳ thi',
    meta: {
      title: 'Số túi và mã phách',
      auth: true
      // permission: 'view-class-list',
    }
  },
  {
    path: '/exam-mark-input',
    component: () => import('@/views/exam/ExamMarkInputPage.vue'),
    name: 'Kỳ thi',
    meta: {
      title: 'Nhập điểm thi',
      auth: true
      // permission: 'view-class-list',
    }
  },
  {
    path: '/exam-mark-view',
    component: () => import('@/views/exam/ExamMarkViewPage.vue'),
    name: 'Kỳ thi',
    meta: {
      title: 'Xem điểm thi',
      auth: true
      // permission: 'view-class-list',
    }
  },
  {
    path: '/head-teacher-exam-mark',
    component: () => import('@/views/exam/ExamHeadTeacherMarkPage.vue'),
    name: 'Kỳ thi',
    meta: {
      title: 'Xem điểm thi',
      auth: true
      // permission: 'view-class-list',
    }
  },
  {
    path: '/teacher-exam-mark',
    component: () => import('@/views/exam/ExamSubjectMarkPage.vue'),
    name: 'Kỳ thi',
    meta: {
      title: 'Xem điểm thi',
      auth: true
      // permission: 'view-class-list',
    }
  },
  {
    path: '/exam-teacher-assignment',
    component: () => import('@/views/exam/ExamTeacherAssignPage.vue'),
    name: 'Kỳ thi',
    meta: {
      title: 'Phân công chấm thi',
      auth: true
      // permission: 'view-class-list',
    }
  },
  {
    path: '/exam-monitor-assignment',
    component: () => import('@/views/exam/ExamMonitorPage.vue'),
    name: 'Kỳ thi',
    meta: {
      title: 'Phân công giám thị',
      auth: true
      // permission: 'view-class-list',
    }
  },
  {
    path: '/exam-mark-review',
    component: () => import('@/views/exam/ExamMarkReviewPage.vue'),
    name: 'Kỳ thi',
    meta: {
      title: 'Phúc khảo thi',
      auth: true
      // permission: 'view-class-list',
    }
  },
  {
    path: '/exam-mark-review/:id',
    component: () => import('@/views/exam/GradeReviewDetailsPage.vue'),
    name: 'Kỳ thi',
    meta: {
      title: 'Phúc khảo thi',
      auth: true
      // permission: 'view-class-list',
    }
  },
  {
    path: '/exam-reports',
    component: () => import('@/views/exam/ExamReportPage.vue'),
    name: 'Kỳ thi',
    meta: {
      title: 'Báo cáo',
      auth: true
      // permission: 'view-class-list',
    }
  },
  {
    path: '/exam-progress-report',
    component: () => import('@/views/exam/ExamProgressReportPage.vue'),
    name: 'Kỳ thi',
    meta: {
      title: 'Báo cáo tiến độ vào điểm',
      auth: true
      // permission: 'view-class-list',
    }
  }
]
